import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';

import { Navigate } from '@sorare/routing';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { MLB_MY_CARDS_CARDS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { AlgoliaCardIndexesNames } from '@sorare/core/src/contexts/config';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { MyCardsSearch } from '@sorare/marketplace/src/searchCards/MyCardsSearch';

import { USInfoModal } from '@sorare/us-sports/src/components/USInfoModal';

import { myClubFilters } from 'components/searchCards/cardFilters';

import { useLayoutData } from './layout';

const availableSorts: AlgoliaCardIndexesNames = [
  'Cards New',
  'Cards Highest Average Score',
  'Cards Highest Price',
  'Cards Lowest Price',
];

const DesktopMLBMyCardsCardsPage = () => {
  const { nbDecks } = useLayoutData();

  const {
    flags: { useMlbSeasonAverageScore = true },
  } = useFeatureFlags();
  const cardFilters = useMemo(
    () =>
      myClubFilters({
        withSeasonScore: useMlbSeasonAverageScore,
        showDecksFilter: nbDecks > 0,
        showRarityFilter: true,
      }),
    [useMlbSeasonAverageScore, nbDecks]
  );
  return (
    <MyCardsSearch
      sport={Sport.BASEBALL}
      analyticsTags={['Gallery', 'Baseball']}
      availableSorts={availableSorts}
      cardFilters={cardFilters}
      playerDetailsComponent={USInfoModal}
    />
  );
};

const MLBMyCardsCardsPage = () => {
  const isDesktopAndAbove = useIsTabletAndAbove();
  if (isDesktopAndAbove) {
    return <DesktopMLBMyCardsCardsPage />;
  }
  return (
    <Navigate
      to={generatePath(MLB_MY_CARDS_CARDS_TYPE, {
        type: Rarity.common,
      })}
    />
  );
};

export default MLBMyCardsCardsPage;
